import React from "react";
import Slider from "react-slick";

import { slideCustom } from "../../page-scripts/script";

// Service array
const service = [
  { imagesUrl: "Mask group (1)", name: "Plumbing" },
  { imagesUrl: "Mask group (2)", name: "Electric Work" },
  { imagesUrl: "Mask group (3)", name: "Carpentry" },
  { imagesUrl: "Mask group (4)", name: "Cleaning Services" },
  { imagesUrl: "Mask group (1)", name: "Plumbing" },
  { imagesUrl: "Mask group (2)", name: "Electric Work" },
  { imagesUrl: "Mask group (3)", name: "Carpentry" },
  { imagesUrl: "Mask group (4)", name: "Cleaning Services" },
];





function CustomSlide({ imagesUrl, name }) {

  return (
    <div style={{ display: "flex", justifyContent: "space-between",width:"1198.31px",margin:'auto'}}>
      <div className="services-imagebox">
        <div className="recent-service-thumbnail">
          <img
            src={`assets/images/${imagesUrl}.png`}
            alt={name}
            className="service-image"
          />
        </div>
        <div className="services-content">
          <div className="services-content-box-inner">
            <p>{name}</p>
          </div>
        </div>
      </div>
      {/* Slick prev button */}

    </div>

    
  );
}

function CustomSlides() {


  return (
   
    <>
     <div className="slider-container  slider-activation slider-digital-agency">

<Slider {...slideCustom}>
  {service.map((item, index) => (
    <CustomSlide
      key={index}
      imagesUrl={item.imagesUrl}
      name={item.name}
    />
  ))}
</Slider>
</div>

    </>
  );
}

export default CustomSlides;
